export const getUniqueMediaItems = (mediaItems) => {
  const seen = new Set();
  return mediaItems.filter((item) => {
    const key = `${item.title}::${item.poster_url}`;
    if (!item.title || !item.poster_url || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
// export const fetchImageAsBase64 = async (url) => {
//   const encodedUrl = encodeURI(url); //

//   const response = await axios.get(encodedUrl, { responseType: "blob" });

//   return new Promise((resolve) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result); // base64 string
//     reader.readAsDataURL(response.data);
//   });
// };

export const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};
export const buildDescriptorSets = (descriptors_data) =>
  descriptors_data.map((block) => {
    const promo = block.mediaTitle?.trim() || "Unknown Promo";

    const answers = block.data ?? [];

    const rows = answers
      .sort((a, b) => b.value - a.value)
      .map((ans) => ({
        label: ans.label,
        value: isNaN(Number(ans.value)) ? 0 : Number(ans.value)
        //value: Math.round(ans.value),
      }));

    return { promo, rows };
  });

export const computeUniversalLabels = (descriptorSets) => {
  if (!descriptorSets.length) return new Set();
  let common = new Set(descriptorSets[0].rows.map((r) => r.label));
  descriptorSets.slice(1).forEach((set) => {
    const labels = new Set(set.rows.map((r) => r.label));
    common = new Set([...common].filter((l) => labels.has(l)));
  });
  return common;
};

export const transformPlatformDataToStreamData = (platform_data) => {
  const grouped = {};

  for (const item of platform_data) {
    const mediaTitle = item.mediaTitle;
    if (!mediaTitle || !Array.isArray(item.data)) continue;

    for (const platform of item.data) {
      const platformName = platform.label;

      if (!grouped[platformName]) {
        grouped[platformName] = {
          name: platformName,
          rows: [],
        };
      }

      grouped[platformName].rows.push({
        label: mediaTitle,
        value: platform.value,
      });
    }
  }

  return Object.values(grouped);
};

export const getCurrentDateFormatted = () => {
  const today = new Date();

  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const year = today.getFullYear();

  return `${month}/${day}/${year}`;
};

export const extractQuestionsWithAnswers = (surveyData, selectedSurvey) => {
  if (
    !surveyData ||
    !selectedSurvey ||
    !surveyData[selectedSurvey] ||
    !surveyData[selectedSurvey].questions
  ) {
    return [];
  }

  const result = [];

  for (const questionId of surveyData[selectedSurvey].questions) {
    const questionObj = surveyData[selectedSurvey][questionId];

    if (!questionObj || !questionObj.data) continue;

    const allAnswers = new Set();
    questionObj.data.forEach((row) => {
      row.data.forEach((item) => {
        if (item.answer) allAnswers.add(item.answer);
      });
    });

    result.push({
      questionId,
      questionText: questionObj.question || questionId,
      answers: Array.from(allAnswers).sort(),
    });
  }

  return result;
};

export function getPivotDataForQuestion(questionData) {
  if (!questionData?.data) return [];

  // Get all unique answers across all groups
  const allAnswers = new Set();
  questionData.data.forEach((row) => {
    row.data.forEach((item) => {
      allAnswers.add(item.answer);
    });
  });
  const sortedAnswers = Array.from(allAnswers).sort(); // column headers

  // Build table rows
  const rows = questionData.data.map((row) => {
    const rowMap = {};
    sortedAnswers.forEach((answer) => {
      const match = row.data.find((item) => item.answer === answer);
      rowMap[answer] = match
        ? `${Math.round(match.percentage_of_answer)}%`
        : "0%";
    });

    return {
      group: row.value,
      ...rowMap,
    };
  });

  return {
    columns: ["Group", ...sortedAnswers],
    rows,
  };
}

export const getAllPivotTablesForSurvey = (surveyData) => {
  if (!surveyData || typeof surveyData !== "object") return [];

  const result = [];

  for (const surveyName of Object.keys(surveyData)) {
    const survey = surveyData[surveyName];
    if (!survey?.questions) continue;

    for (const questionId of survey.questions) {
      const questionData = survey[questionId];
      const questionText = questionData?.question || questionId;

      // Collect all possible answers
      const allAnswers = new Set();
      questionData?.data?.forEach((row) => {
        row.data.forEach((item) => allAnswers.add(item.answer));
      });
      const sortedAnswers = Array.from(allAnswers).sort();

      const rows =
        questionData?.data?.map((row) => {
          const rowMap = new Map(
            row.data.map((item) => [
              item.answer,
              item.percentage_of_answer || 0,
            ])
          );

          const data = sortedAnswers.map((answer) => ({
            label: answer,
            value: Math.round(rowMap.get(answer) || 0),
          }));

          return {
            mediaTitle: row.value,
            data,
          };
        }) || [];

      result.push({
        surveyName,
        questionId,
        questionText,
        columns: ["Group", ...sortedAnswers],
        rows,
      });
    }
  }

  return result;
};

// export const findQuestionPivotByIdOrText = (
//   customPivotData,
//   searchKey,
//   rowLimit
// ) => {
//   if (!customPivotData || !searchKey) return null;

//   // 1. Match questionId exactly
//   let matched = customPivotData.find((q) => q.questionId === searchKey);

//   // 2. Fallback: Match questionText partially
//   if (!matched) {
//     const lowerKey = searchKey.toLowerCase();
//     matched = customPivotData.find((q) =>
//       q.questionText?.toLowerCase().includes(lowerKey)
//     );
//   }

//   if (!matched) return null;

//   // 3. Apply rowLimit inside each `data` array
//   const limitedRows = matched.rows.map((row) => ({
//     ...row,
//     data: rowLimit ? row.data.slice(0, rowLimit) : row.data,
//   }));

//   return {
//     ...matched,
//     rows: limitedRows,
//   };
// };
export const findQuestionPivotByIdOrText = (
  customPivotData,
  searchKey,
  rowLimit
) => {
  if (!customPivotData || !searchKey) return null;

  // 1. Match questionId exactly
  let matched = customPivotData.find((q) => q.questionId === searchKey);

  // 2. Fallback: Match questionText partially
  if (!matched) {
    const lowerKey = searchKey.toLowerCase();
    matched = customPivotData.find((q) =>
      q.questionText?.toLowerCase().includes(lowerKey)
    );
  }

  if (!matched) return null;

  // 3. Apply rowLimit inside each `data` array
  const limitedRows = matched.rows.map((row) => ({
    ...row,
    data: rowLimit ? row.data.slice(0, rowLimit) : row.data,
  }));

  // 4. Return only rows
  return limitedRows;
};

export const extractGenderAgeGroups = (pivotData) => {
  const result = [];

  // Get the question key
  const questionKey = "Who do you think would be most interested in watching this show?"
  // Object.keys(pivotData.post)[1];
  const allEntries = pivotData?.post?.[questionKey]?.data;
  if (allEntries?.length > 0) {
    allEntries.forEach((item) => {
      item?.data.forEach((entry) => {
        const isGender = entry.answer === "Men" || entry.answer === "Women";
        const isAgeGroup = entry.demographic_category === "agegroup";
        if (isGender && isAgeGroup) {
          result.push({
            mediaSubTitle: item?.value,
            key: `${entry.answer} ${entry.demographic_value}`,
            count: entry.count,
            percentage_of_demographic: entry.percentage_of_demographic,
            question: entry.question,
            title: entry.title,
          });
        }
      });
    });
  }


  return result;
};

// export const formatGroupedDataToChartWithAdults = (
//   data,
//   brandColor = "F9E6E6",
//   norm = 40
// ) => {
//   const grouped = {};
//   const adultsCombined = {};

//   data.forEach((item) => {
//     const parts = item.key.split(" "); // e.g., "Women 45-54"
//     const gender = parts[0];
//     const ageGroup = parts.slice(1).join(" ");
//     const demo = item.key;

//     // Group by gender + ageGroup
//     if (!grouped[demo]) {
//       grouped[demo] = {
//         demo,
//         brandColor,
//         norm,
//         bars: [],
//       };
//     }

//     grouped[demo].bars.push({
//       color: gender === "Women" ? "D24B4B" : "4B88D2",
//       label: item.mediaSubTitle || "High Potential",
//       value: item.percentage_of_demographic || 0,
//     });

//     // Aggregate for Adults
//     if (!adultsCombined[ageGroup]) {
//       adultsCombined[ageGroup] = [];
//     }
//     adultsCombined[ageGroup].push(item);
//   });

//   // Create Adults {ageGroup} group
//   Object.entries(adultsCombined).forEach(([ageGroup, entries]) => {
//     const combinedBars = entries.map((entry) => ({
//       label: entry.mediaSubTitle || "High Potential",
//       value: entry.percentage_of_demographic || 0,
//     }));

//     const mergedByLabel = {};
//     combinedBars.forEach(({ label, value }) => {
//       if (!mergedByLabel[label]) mergedByLabel[label] = 0;
//       mergedByLabel[label] += value;
//     });

//     const bars = Object.entries(mergedByLabel).map(([label, value]) => ({
//       color: "7B61FF", // Purple for Adults
//       label,
//       value: parseFloat(value.toFixed(2)),
//     }));

//     grouped[`Adults ${ageGroup}`] = {
//       demo: `Adults ${ageGroup}`,
//       brandColor,
//       norm,
//       bars,
//     };
//   });

//   // Sort the final output in dynamic order: Adults → Men → Women, each by ascending value
//   const labelPriority = (label) => {
//     const lower = label.toLowerCase();
//     if (lower.includes("adults")) return 0;
//     if (lower.includes("men")) return 1;
//     if (lower.includes("women")) return 2;
//     return 3;
//   };

//   return Object.values(grouped)
//     .sort((a, b) => {
//       const groupA = labelPriority(a.demo);
//       const groupB = labelPriority(b.demo);
//       if (groupA !== groupB) return groupA - groupB;
//       return 0;
//     })
//     .map((group) => ({
//       ...group,
//       bars: group.bars.sort((a, b) => a.value - b.value),
//     }));
// };

export const formatGroupedDataToChartWithAdults = (data, norm = 40) => {
  const grouped = {};
  const adultsCombined = {};

  data.forEach((item) => {
    const parts = item.key.split(" "); // e.g., "Women 45-54"
    const gender = parts[0];
    const ageGroup = parts.slice(1).join(" ");
    const ageLabel = item.key;

    // Determine brand color
    const brandColor =
      gender === "Women" ? "F9E6E6" : gender === "Men" ? "E6EEF9" : "E5E5E5"; // fallback

    // Group by gender + ageGroup
    if (!grouped[ageLabel]) {
      grouped[ageLabel] = {
        ageLabel,
        brandColor,
        norm,
        bars: [],
      };
    }

    grouped[ageLabel].bars.push({
      color: gender === "Women" ? "D24B4B" : "4B88D2", // bar color
      label: item.mediaSubTitle || "High Potential",
      value: item.percentage_of_demographic || 0,
    });

    // Aggregate for Adults
    if (!adultsCombined[ageGroup]) {
      adultsCombined[ageGroup] = [];
    }
    adultsCombined[ageGroup].push(item);
  });

  // Create Adults {ageGroup} group
  Object.entries(adultsCombined).forEach(([ageGroup, entries]) => {
    const combinedBars = entries.map((entry) => ({
      label: entry.mediaSubTitle || "High Potential",
      value: entry.percentage_of_demographic || 0,
    }));

    const mergedByLabel = {};
    combinedBars.forEach(({ label, value }) => {
      if (!mergedByLabel[label]) mergedByLabel[label] = 0;
      mergedByLabel[label] += value;
    });

    const bars = Object.entries(mergedByLabel).map(([label, value]) => ({
      color: "7B61FF", // Purple for Adults
      label,
      value: parseFloat(value.toFixed(2)),
    }));

    grouped[`Adults ${ageGroup}`] = {
      ageLabel: `Adults ${ageGroup}`,
      brandColor: "E5E5E5", // Light gray for Adults
      norm,
      bars,
    };
  });

  // Sort in the order: Adults → Men → Women
  const labelPriority = (label) => {
    const lower = label.toLowerCase();
    if (lower.includes("adults")) return 0;
    if (lower.includes("men")) return 1;
    if (lower.includes("women")) return 2;
    return 3;
  };

  return Object.values(grouped)
    .sort((a, b) => {
      const groupA = labelPriority(a.ageLabel);
      const groupB = labelPriority(b.ageLabel);
      if (groupA !== groupB) return groupA - groupB;
      return 0;
    })
    .map((group) => ({
      ...group,
      bars: group.bars.sort((a, b) => a.value - b.value),
    }));
};

export const buildAgeOrdered = (chartSets) => {
  const groupedByAge = {};

  chartSets.forEach((set) => {
    const [group, age] = set.ageLabel.split(" ");
    if (!groupedByAge[age]) groupedByAge[age] = {};
    groupedByAge[age][group] = set.ageLabel;
  });

  const preferredGroupOrder = ["Adults", "Women", "Men"];

  const slides = Object.entries(groupedByAge)
    .sort(([ageA], [ageB]) => {
      // Sort age bands numerically, e.g., "18-24" < "25-34"
      const aStart = parseInt(ageA.split("-")[0], 10);
      const bStart = parseInt(ageB.split("-")[0], 10);
      return aStart - bStart;
    })
    .map(([age, groupMap]) =>
      preferredGroupOrder.map((group) => groupMap[group]).filter(Boolean)
    )
    .filter((slide) => slide.length > 0); // remove empty slides

  return slides;
};

export const getQuestionResponseByIdOrText = (
  questionData,
  searchKey,
  topN
) => {
  if (!questionData || !searchKey) return null;

  // Exact match on question_id
  let matched = questionData.find((q) => q.question_id === searchKey);

  // Partial match on question text
  if (!matched) {
    const lowerKey = searchKey.toLowerCase();
    matched = questionData.find((q) =>
      q.question?.toLowerCase().includes(lowerKey)
    );
  }

  if (!matched) return null;

  // Sort and limit
  const sortedData = [...matched.data].sort((a, b) => b.value - a.value);
  const limitedData = topN ? sortedData.slice(0, topN) : sortedData;

  return {
    question: matched.question,
    question_id: matched.question_id,
    data: limitedData,
  };
};

export const transformPlatformUseToMediaFormat = (
  questionBlock,
  mediaTitle = "Platform Use - General"
) => {
  if (!questionBlock || !Array.isArray(questionBlock.data)) return [];

  const transformed = {
    mediaTitle,
    data: questionBlock.data.map((item) => ({
      label: item.name,
      value: item.value,
    })),
  };

  return [transformed];
};
export const transformDescriptorsToMediaFormat = (
  questionBlock,
  mediaTitle = "Descriptors"
) => {
  if (!questionBlock || !Array.isArray(questionBlock.data)) return [];
  return [
    {
      mediaTitle,
      data: questionBlock.data.map((item) => ({
        label: item.name,
        value: Number(item.value)|| 0,
      })),
    },
  ];
};
